<template>
  <div id="app">
    <div>
      <div class="container">
        <div class="row">
          <div class="col-6 text-left">
            <img class="logo" alt="Saeg S.r.l." src="./assets/logo.png" style="max-width: 150px;">
          </div>
          <div class="col-6 text-right nav_header mt-3" v-show="!homePage">
            <a v-on:click="onHome()">
              <b-icon-house-door-fill></b-icon-house-door-fill>
            </a>
          </div>
          <div class="col-md-6 offset-md-3" style="padding-right: 5px; padding-left: 5px;">
            <div v-if="alert.message" :class="`alert ${alert.type}`">{{ alert.message }}</div>
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {router} from "@/_helpers";
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'vue2-autocomplete-js/dist/style/vue2-autocomplete.css';

Vue.use(VueToast);

export default {
  name: 'App',
  data() {
    return {
      toast: null,
      checkServerOnlineInterval: 0,
      checkServerOnlineIntervalDate: 0,
      onLine: navigator.onLine,
      isErrorServer: false,
    }
  },
  created () {
    window.setInterval(() => {
      if( this.checkServerOnlineInterval == 0 || ( (this.checkServerOnlineIntervalDate + 13000) < new Date().getTime() )  )
      {
        this.checkServerOnlineIntervalDate = new Date().getTime();
        this.checkServerOnlineInterval = 1;
        this.checkServerOnline();
      }
    }, 10000);
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  computed: {
    ...mapState({
      alert: state => state.alert
    }),
    homePage() {
      if (this.$route.path == "/" || this.$route.path == "/home") {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...
        mapActions({
          clearAlert: 'alert/clear'
        }),
    onHome() {
      router.push('/');
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === 'online';
    },
    checkServerOnline(){
      //this.isErrorServer = true;
      fetch(`https://ordini.saegsrl.com/iserrorenabled.txt`).then(this.handleResponseError);
    },
    handleResponseError(response){
      return response.text().then(text => {
        this.isErrorServer = (parseInt(text) == 0);
        this.checkServerOnlineInterval = 0;
      });
    }
  }
  ,
  watch: {
    $route() {
      // clear alert on location change
      this.clearAlert();
    },
    isErrorServer(v)
    {
      if(!v)
      {
        if(this.toast) {
          this.toast.dismiss();
          this.toast = Vue.$toast.open({
            message: 'Problema connessione server ripristinata.',
            type: 'success',
            duration: 3000,
            dismissible: true,
            position: 'top'
          });
          document.getElementById("app").className = '';
        }
      }
      else
      {
        this.toast = Vue.$toast.open({
          message: 'Attenzione! Problema connessione server!.',
          type: 'error',
          duration: 0,
          dismissible: false,
          position: 'top'
        });
        document.getElementById("app").className = 'offline';
      }
    },
    onLine(v) {
        if(v)
        {
          this.toast.dismiss();
          this.toast = Vue.$toast.open({
            message: 'Connessione internet ripristinata.',
            type: 'success',
            duration: 3000,
            dismissible: true,
            position: 'top'
          });
          document.getElementById("app").className = '';
        }else
        {
          this.toast = Vue.$toast.open({
            message: 'Attenzione! Hai problemi con la connessione internet del tuo smartphone.',
            type: 'error',
            duration: 0,
            dismissible: false,
            position: 'top'
          });
          document.getElementById("app").className = 'offline';
        }
    }
  }
}
</script>